module.exports = __webpack_public_path__ + "img/user.bf91ac67.svg";